import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initial-state";
import { assignRequest } from "./thunks/assign-request";
import { getDeliveryDetail } from "./thunks/get-delivery-detail";
import { listAmbassadorLoads } from "./thunks/list-ambassador-loads";
import { listAmbassadorZones } from "./thunks/list-ambassador-zones";
import { listAmbassadors } from "./thunks/list-ambassadors";
import { listQueue } from "./thunks/list-queue";
import { queryQueue } from "./thunks/query-queue";

const name = "assignment";

export const slice = createSlice({
  name,
  initialState,
  reducers: {
    /** Closes the detail panel. The delivery goes with it: reopening another
     *  row must not flash the previous customer's data while it loads. */
    clearDetail: (state) => {
      state.detail = null;
      state.isDetailPending = false;
      state.isDetailRejected = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // The queue read drives the screen's loading/error state.
      .addCase(listQueue.pending, (state) => {
        state.isPending = true;
        state.isRejected = false;
        state.errorMessage = "";
      })
      .addCase(listQueue.fulfilled, (state, action) => {
        state.queue = action.payload;
        state.isPending = false;
        state.isRejected = false;
      })
      .addCase(listQueue.rejected, (state, action) => {
        state.isPending = false;
        state.isRejected = true;
        state.errorMessage = action.error.message ?? "";
      })
      // Ambassadors, loads and zones populate their slices; none of them gates
      // the screen — the table is useful before the assign modal can open.
      .addCase(listAmbassadors.fulfilled, (state, action) => {
        state.ambassadors = action.payload;
      })
      .addCase(listAmbassadorLoads.fulfilled, (state, action) => {
        state.loads = action.payload;
      })
      .addCase(listAmbassadorZones.fulfilled, (state, action) => {
        state.zones = action.payload;
      })
      .addCase(queryQueue.pending, (state) => {
        state.isQuerying = true;
      })
      .addCase(queryQueue.fulfilled, (state, action) => {
        state.queryRows = action.payload;
        state.isQuerying = false;
      })
      .addCase(queryQueue.rejected, (state) => {
        // A failed query must not read as "nothing matched": clearing it
        // leaves the full queue on screen instead of an unexplained blank.
        state.queryRows = null;
        state.isQuerying = false;
      })
      .addCase(getDeliveryDetail.pending, (state) => {
        state.isDetailPending = true;
        state.isDetailRejected = false;
        state.detail = null;
      })
      .addCase(getDeliveryDetail.fulfilled, (state, action) => {
        state.detail = action.payload;
        state.isDetailPending = false;
      })
      .addCase(getDeliveryDetail.rejected, (state) => {
        state.isDetailPending = false;
        state.isDetailRejected = true;
      })
      .addCase(assignRequest.pending, (state) => {
        state.isAssigning = true;
        state.assignError = "";
      })
      .addCase(assignRequest.fulfilled, (state) => {
        state.isAssigning = false;
      })
      .addCase(assignRequest.rejected, (state, action) => {
        state.isAssigning = false;
        state.assignError = action.error.message ?? "";
      });
  },
});

export const actions = slice.actions;
export const reducer = slice.reducer;
